// @todo Refactor the entire class to be dynamic and avoid extra code
class Modal extends DrupalBehavior {
  stringToHTML(str) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(str, 'text/html');
    return doc.body;
  }

  buildForm() {
    const form = document.getElementById('webform--wrap-form');

    return form;
  }

  appendForm() {
    const form = this.buildForm();

    document.getElementById('modal--overlay').querySelector('.modal--body').appendChild(form);
  }

  getYouTubeID(url) {
    if (url.includes('watch?v=')) {
      url = url.split('watch?v=');
    } else {
      url = url.split('https://youtu.be/');
    }

    if (url[1].includes('&')) {
      return url[1].slice(0, url[1].indexOf('&'));
    } else {
      return url[1];
    }
  }

  getVimeoID(url) {
    url = (url.replace('https://', '')).split('/');
    if (url[1]) {
      return url[1];
    }
  }

  isVimeoUrl(url) {
    try {
      const host = new URL(url).hostname;
      return host === 'vimeo.com' || host.endsWith('.vimeo.com');
    } catch (e) {
      return false;
    }
  }

  buildYoutubeEmbed(button) {
    const videoUrl = button.getAttribute('data-video-url');
    if (this.isVimeoUrl(videoUrl)) {
      const vimeoID = this.getVimeoID(videoUrl);
      return (
        `<div class="embed-container">
                     <iframe
                         src="https://player.vimeo.com/video/${vimeoID}?app_id=122963"
                         width="640" height="360"
                         frameborder="0"
                         allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
                         allowFullScreen>
                     </iframe>
                </div>`
      );
    } else {
      const videoID = this.getYouTubeID(videoUrl);
      return (
        `<div class="embed-container">
                    <iframe
                        src="https://www.youtube.com/embed/${videoID}?version=3&enablejsapi=1?autoplay=1"
                        frameborder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen>
                    </iframe>
                </div>`
      );
    }
  }


  appendYoutubeEmbed(button) {
    const iframe = this.stringToHTML(this.buildYoutubeEmbed(button));

    [...iframe.childNodes].forEach((node) => {
      document.getElementById('modal--overlay').querySelector('.modal--body').appendChild(node);
    })
  }

  mask() {
    if (!document.getElementById('modal--overlay')) {
      const mask = document.createElement('div');
      mask.setAttribute('id', 'modal--overlay');

      document.querySelector('.site-wrap').appendChild(mask);
    }
  }

  build(type) {
    const modalHTML = `<div class="modal--wrap ${type}" data-${type}-modal>
                                <div class="modal--dialog">
                                    <div class="modal--content">
                                        <div class="modal--header">
                                            <button class="close" data-modal-close>Close modal</button>
                                        </div>
                                        <div class="modal--body"></div>
                                    </div>
                                </div>
                            </div>`;

    return modalHTML;
  }

  open(modalParent, type, button, callback, context) {
    if (button.length > 0) {
      [...button].forEach((item) => {
        once('OpenModal', item, context).forEach(() => {

          item.addEventListener('click', (e) => {
            this.mask();

            const maskEl = document.getElementById('modal--overlay');
            const modal = this.stringToHTML(this.build(type, parent));

            [...modal.childNodes].forEach((node) => {
              if (!maskEl.querySelector(`[data-${type}-modal]`)) {
                maskEl.appendChild(node);
                setTimeout(() => {
                  maskEl.querySelector('.modal--wrap').classList.add('active');
                  maskEl.classList.add('active');
                }, 200);
                maskEl.addEventListener('click', this.close, false);
              }
            });

            callback(e.target);
          });
        });
      })
    }
  }

  close(e) {
    e.stopPropagation();

    const mask = document.getElementById('modal--overlay');
    const wrap = document.querySelector('.modal--wrap');

    if (e.target.getAttribute('id') === 'modal--overlay' || e.target.classList.contains('close')) {
      mask.classList.remove('active');
      wrap.classList.remove('active');
      setTimeout(function () {
        if (mask.querySelector('.webform')) {
          const form = document.getElementById('webform--wrap-form');
          document.getElementById('webform--wrap').appendChild(form);
        }
        mask.innerHTML = '';
      }, 250);
    }
  }

  modal(parent, type, button, callback, context) {
    this.open(parent, type, button, callback, context);
  }

  onContent(context) {
    this.appendYoutubeEmbed = this.appendYoutubeEmbed.bind(this);
    this.appendForm = this.appendForm.bind(this);

    const hero = context.querySelector('.hero--video');
    if (hero) {
      const videoModal = document.querySelectorAll('.hero--video-button--toggle');
      if (videoModal) {
        this.modal('.videos--item', 'video', videoModal, this.appendYoutubeEmbed);
      }
    }

    const featuredCallout = context.querySelector('.featured-callout--video');
    if (featuredCallout) {
      const videoModal = document.querySelectorAll('.videos--toggle');
      if (videoModal) {
        this.modal('.videos--item', 'video', videoModal, this.appendYoutubeEmbed);
      }
    }

    const doctorDetail = context.querySelector('.doctor');
    if (doctorDetail) {
      const videoModal = document.querySelectorAll('.videos--item button');
      if (videoModal) {
        this.modal('.videos--item', 'video', videoModal, this.appendYoutubeEmbed);
      }

      const formModal = document.querySelectorAll('.doctor-profile--contact .modal-toggle');
      if (formModal) {
        this.modal('.doctor-profile', 'webform', formModal, this.appendForm, context);
      }
    }

    const DoctorLanding = context.querySelector('.find-a-doctor');
    if (DoctorLanding) {
      const formModal = document.querySelectorAll('.doctor-teaser a.use-ajax');
      if (formModal) {
        this.modal('.doctor-teaser', 'webform', formModal, this.appendForm, context);
      }
    }
  }
}

DrupalBehavior.register('summit_theme', 'modal', Modal);
